function getLevel (altitude) {
  if (window.loclyLocation.isUnifiedInsideAltitude(10, 19)) {
    return 'gallery1'
  }
  if (window.loclyLocation.isUnifiedInsideAltitude(40, 49)) {
    return 'gallery4'
  }
  if (window.loclyLocation.isUnifiedInsideAltitude(60, 69)) {
    return 'gallery6'
  }

  return 'ground'
}

export default getLevel
